import {ParamMap} from "@angular/router";
import {inject} from "@angular/core";
import {ApartmentService} from "./services/apartment.service";
import {map, of} from "rxjs";

export const getApartmentCanonical = (data: ParamMap) => {
  const id = data.get('lotteryId');

  if (id) {
    return inject(ApartmentService).getApartment(id).pipe(
      map(lottery => {
        return `/apartments/${lottery.slug ?? lottery.id}`;
      }));
  }
  return of(`/apartments/${id}`);
}
